/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBoxMultiple4 = createReactComponent("box-multiple-4", "IconBoxMultiple4", [
  [
    "path",
    {
      d: "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2",
      key: "svg-1"
    }
  ],
  ["path", { d: "M15 14v-8l-4 6h5", key: "svg-2" }]
]);

export { IconBoxMultiple4 as default };
//# sourceMappingURL=IconBoxMultiple4.js.map
